





















import { Section } from './mixins';

import { Component, Vue, Prop, Mixins, Emit, Watch } from 'vue-property-decorator';

@Component({
  components: {
    FormWysiwyg: () => import('@/components/forms/Wysiwyg.vue'),
  },
})
export default class SectionTechnicals extends Mixins(Section) {
  @Prop() readonly value!: SectionTechnicals;
}
